var exports = {
  "U": "x8b4e8595--2b83e3--arrow",
};

module.exports = exports;
